import { AccountingPayableObjectTypeEnum, ObjectType } from "#graphql/supergraphEnums";
import { toDbId } from "#utils/graphql_utils";

const OBJECT_TYPE_TO_PATH_SEGMENT: Record<string, string> = {
  [ObjectType.DistributionBatch]: "distribution_batch",
  [ObjectType.CapitalCallBatch]: "capital_call_batch",
  [ObjectType.TransactionBatch]: "capital_activity_batch",
};

const PAYABLE_TO_PAYMENT_OBJECT_TYPE: Record<string, ObjectType> = {
  [AccountingPayableObjectTypeEnum.DistributionBatch]: ObjectType.DistributionBatch,
  [AccountingPayableObjectTypeEnum.CapitalCallBatch]: ObjectType.CapitalCallBatch,
  [AccountingPayableObjectTypeEnum.TransactionBatch]: ObjectType.TransactionBatch,
};

/**
 * Builds the Pyramid deep-link for a batch's transaction-description link.
 * Shared by both the payable and non-payable paths; TransactionBatch
 * resolves to the per-batch `capital_activity_batch/{dbId}` route.
 */
export const buildTransactionUrl = (
  objectType: string,
  id: string,
  hostName: string,
  fallbackSegment: string | null = null,
): string | null => {
  const dbId = toDbId(id);
  if (!dbId) return null;

  const segment = OBJECT_TYPE_TO_PATH_SEGMENT[objectType] ?? fallbackSegment;
  if (!segment) return null;

  return `https://${hostName}/${segment}/${dbId}`;
};

/**
 * Maps an `AccountingPayableObjectTypeEnum` (payable subgraph) to the
 * equivalent payments `ObjectType` so payable call sites can feed
 * `buildTransactionUrl`. Returns `null` for enum members that have no batch
 * route (e.g. `NetIncomeBatch`); callers should render plain text in that case.
 */
export const payableObjectTypeToObjectType = (
  objectType: AccountingPayableObjectTypeEnum,
): ObjectType | null => PAYABLE_TO_PAYMENT_OBJECT_TYPE[objectType] ?? null;
